import React from 'react'

import BaseInput from './BaseInput';

export default function PasswordInput(props) {
    return (
        <BaseInput {...props}
                   type="password"/>
    )
}